/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { BodyStats_Input } from "../models/BodyStats_Input";
import type { DataMessageResponse_BodyStats_ } from "../models/DataMessageResponse_BodyStats_";
import type { DataResponse_BodyStats_ } from "../models/DataResponse_BodyStats_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class BodyStatsService {
  /**
   * Update Body Stats
   * Updates the body stats for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_BodyStats_ Successful Response
   * @throws ApiError
   */
  public static updateBodyStatsApiV1BodyStatsPut(
    xUserId: string,
    requestBody: BodyStats_Input,
  ): CancelablePromise<DataMessageResponse_BodyStats_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/body-stats",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Body Stats
   * Returns the body stats for a user.
   * @param xUserId
   * @returns DataResponse_BodyStats_ Successful Response
   * @throws ApiError
   */
  public static getBodyStatsApiV1BodyStatsGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_BodyStats_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/body-stats",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Body Stats By Admin
   * Used by an admin to get information about a user's body stats.
   * @param userId
   * @returns DataResponse_BodyStats_ Successful Response
   * @throws ApiError
   */
  public static getBodyStatsByAdminApiV1BodyStatsUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_BodyStats_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/body-stats/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
